import React from 'react';
import { Outlet } from 'react-router-dom';
import MatriculationNavigation from '../shared/layout/MatriculationNavigation';

const Matriculation = () => {
  return (
    <>
      <MatriculationNavigation />
      <Outlet />
    </>
  );
};

export default Matriculation;
